export class AddressInfo {
    constructor({
        streetType = null,
        streetName = null,
        streetNumber = null,
        block = null,
        lotNumber = null,
        urbanizationType = null,
        urbanizationName = null,
        geoAddress = null,
        latitude = null,
        longitude = null,
    } = {}) {
        this.streetType = streetType;
        this.streetName = streetName;
        this.streetNumber = streetNumber;
        this.block = block;
        this.lotNumber = lotNumber;
        this.urbanizationType = urbanizationType;
        this.urbanizationName = urbanizationName;
        this.geoAddress = geoAddress;
        this.latitude = latitude;
        this.longitude = longitude;
    }
}
